import { kmsClient } from 'api';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import {
  RefreshArticleGroupInterestsMutation,
  RefreshArticleGroupInterestsMutationVariables
} from './__generated__/RefreshArticleGroupInterestsMutation';

export const REFRESH_ARTICLE_GROUP_INTERESTS = gql`
  mutation RefreshArticleGroupInterestsMutation($articleGroupId: ID!) {
    refreshArticleGroupInterests(articleGroupId: $articleGroupId) {
      successful
      errors
    }
  }
`;

export const useRefreshArticleGroupInterestsMutation = () => {
  return useMutation<RefreshArticleGroupInterestsMutation, RefreshArticleGroupInterestsMutationVariables>(
    REFRESH_ARTICLE_GROUP_INTERESTS,
    { client: kmsClient, notifyOnNetworkStatusChange: true }
  );
};
